import React from "react";
import { ComponentProps } from "../../types/types";
import { RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import "../../styles/@shared/hero-banner.scss";
import { HeroBannerModel } from "./models/HeroBanner.model";
import LazySection from "../../react-only-components/LazySection";

interface HeroBannerProps extends ComponentProps {}

const HeroBanner = (props: HeroBannerProps) => {
  const model = new HeroBannerModel(props);
  const getVariation = () => {
    return props?.params?.Variation?.toLowerCase();
  };
  const getHeight = () => {
    return props?.params?.HeightSize?.toLowerCase();
  };
  const variation = getVariation();
  const height = getHeight();

  return (
    <LazySection id={props?.rendering?.uid}>
      {props.fields && (
        <div
          className={`hero-banner hero-banner--${variation}  hero-banner__${height}`}
        >
          <div
            style={{ backgroundImage: `url(${model?.image?.value?.src})` }}
            className={`hero-banner__image hero-banner__image--desktop hero-banner__image--desktop-${height}`}
          ></div>

          <div
            style={{
              backgroundImage: `url(${
                model?.imageMobile?.value?.src &&
                model?.imageMobile?.value ? model?.imageMobile?.value?.src : model?.image?.value?.src
              })`,
            }}
            className="hero-banner__image hero-banner__image--mobile"
          ></div>
          <div
            className={`hero-banner__content hero-banner__content--${variation} hero-banner__content--${height}`}
          >
            <div className="hero-banner-content-wrapper">
              <RichText
                tag="p"
                field={model?.eyebrow}
                className={`hero-banner__eyebrow hero-banner__eyebrow--${variation}`}
              />
              <RichText
                tag="h1"
                field={model?.title}
                className={`hero-banner__title hero-banner__title--${variation}`}
              />
              <RichText
                tag="p"
                field={model?.description}
                className={`hero-banner__description hero-banner__description--${variation}`}
              />
              {model?.primaryLink?.value?.href && (
                <div className={"hero-banner__link"}>
                  <Link field={model?.primaryLink} />
                </div>
              )}
              {model?.secondaryLink?.value?.href && (
                <span className={"hero-banner__link"}>
                  <Link field={model?.secondaryLink} />
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </LazySection>
  );
};

export default HeroBanner;
